import { render } from "./IndicatorSelector.vue?vue&type=template&id=5bd474ab&scoped=true"
import script from "./IndicatorSelector.vue?vue&type=script&lang=js"
export * from "./IndicatorSelector.vue?vue&type=script&lang=js"

import "./IndicatorSelector.vue?vue&type=style&index=0&id=5bd474ab&scoped=true&lang=css"
import "./IndicatorSelector.vue?vue&type=style&index=1&id=5bd474ab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd474ab"]])

export default __exports__